// Modal.tsx
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import styles from './Modal.module.css';

export interface ModalParams {
  backgroundColor: string;
  textColor: string;
}

type ModalProps = {
  open: boolean;
  onClose: () => void;
  params?: ModalParams;
  children: React.ReactNode;
};

export default function Modal({ open, onClose, params = { backgroundColor: "#f3efe6", textColor: "#124344" }, children }: ModalProps) {

  // lock body scroll while open
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div
      aria-hidden={!open}
      onClick={onClose}
      className={styles.backdrop}
    >
      <div
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        className={styles.dialog}
        style={{backgroundColor: params.backgroundColor, color: params.textColor}}
      >
        <button className={styles.closeBtn} onClick={onClose} aria-label="Close" style={{color: params.textColor}}>×</button>
        {children}
      </div>
    </div>,
    document.body
  );
}
